module.exports = __webpack_public_path__ + "img/ContactUsMobileHero.cdad71ca.png";